import React from 'react';
import MusicExperience from './MusicExperience';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="w-screen h-screen">
        <MusicExperience />
      </div>
    </div>
  );
}

export default App;